import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('config');
    }

    update (data) {
        return this.client.request({
            method: 'put',
            path: `/publisher/v1/${this.resourceName}`,
            data: data,
        });
    }
}

export default new Resource;
